import { EMPTY_LIST } from '../../../../constants/common'
import { CurrencySelect } from '../../../Currency'

function ProfileInfoWidgetCurrencyField({
  currencyOptions = EMPTY_LIST,
  disabled,
  error,
  qaName,
  value,
  onChange,
}) {
  return (
    <CurrencySelect
      controlProps={{ borderless: false }}
      currencyOptions={currencyOptions}
      disabled={disabled}
      error={error}
      qaName={qaName}
      value={value}
      onChange={onChange}
    />
  )
}

export default ProfileInfoWidgetCurrencyField
